import React from "react";
import { Menu, Moon, Sun, X } from "lucide-react";

const Navbar = ({
  scrolled,
  isMenuOpen,
  setIsMenuOpen,
  activeSection,
  scrollToSection,
  isLightTheme,
  toggleTheme,
}) => {
  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <span>Portfolio</span>
        </div>

        <div className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
          {["home", "about", "experience", "skills", "projects", "contact"].map(
            (item) => (
              <button
                key={item}
                className={`nav-link ${activeSection === item ? "active" : ""}`}
                onClick={() => scrollToSection(item)}
              >
                {item.charAt(0).toUpperCase() + item.slice(1)}
              </button>
            ),
          )}
        </div>

        <button
          className="theme-toggle"
          onClick={toggleTheme}
          aria-label={
            isLightTheme ? "Switch to dark theme" : "Switch to light theme"
          }
          title={
            isLightTheme ? "Switch to dark theme" : "Switch to light theme"
          }
        >
          {isLightTheme ? <Moon size={18} /> : <Sun size={18} />}
        </button>

        <button
          className="nav-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label={
            isMenuOpen ? "Close navigation menu" : "Open navigation menu"
          }
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
